<template>
  <div class="article-box">
    <h5 class="article_title">新手指引</h5>
    <hr>
    <div class="article_content" v-html="data">
     <!-- <p class="assist">
        第一步：点击
        <span class="red">"用户中心"</span>
      </p>
      <p>
        <img class="imgassist" src="g./a26b7s/61g.jpg">
      </p>
      <p class="assist">
        第二步：点击
        <span class="red">"在线注册"</span>分别填写
        <span class="red">"手机号"</span>—
        <span class="red">"验证码"</span>-
        <span class="red">"手机验证码"</span>-
        <span class="red">"密码"</span>-
        <span class="red">"推荐人手机码"</span>(可填可不填)
      </p>
      <p>
        <img class="imgassist" src="g./a031cs/e7g.jpg">
      </p>
      <p class="assist">
        第三步：点击
        <span class="red">"用户登录"</span>&nbsp; &nbsp;分别输入
        <span class="red">"手机号"</span>—
        <span class="red">"密码"</span>-
        <span class="red">"验证码"</span>—点击进入
      </p>
      <p>
        <img class="imgassist" src="g./ae0f9s/acg.jpg" title="3.jpg" alt="3.jpg">
      </p>
      <p class="assist">
        第四步:点击
        <span class="red">"用户中心"</span>—选择
        <span class="red">"充值提现"</span>-
        <span class="red">"充值金额"</span>-填写
        <span class="red">"相关信息"</span>—点击
        <span class="red">"确定"</span>提交
      </p>
      <p>
        <img class="imgassist" src="g./a64fes/c8g.png" title="4.png" alt="4.png">
      </p>
      <p class="assist">
        第五步：选择您的配资玩法—直接点击
        <span class="red">"VIP配资"</span>\
        <span class="red">"按周配资"</span>\
        <span class="red">"按月配资"</span>\
        <span class="red">"按周配资"</span>\
        <span class="red">"免息配资"</span>\(针对新玩家),我们以
        <span class="red">"按天配资"</span>
      </p>
      <p>
        <img class="imgassist" src="g./a7e66s/b1g.png" title="4.png" alt="4.png">
      </p>
      <p class="assist">
        第六步：提交申请之后,我们可以点击
        <span class="red">"用户中心"</span>—点击
        <span class="red">"配资账户"</span>—进行
        <span class="red">"实盘交易"</span>
      </p>
      <p>
        <img class="imgassist" src="g./afeees/9cg.png">
      </p>
      <p class="assist">
        第七步：点击实盘交易后进入实盘操作—输入
        <span class="red">股票代码</span>—选择
        <span class="red">购买信息</span>—点击
        <span class="red">确认交易</span>
      </p>
      <p>
        <img class="imgassist" src="g./ad025s/4bg.png">
        <img class="imgassist" src="g./a9d0cs/70g.png">
        <img class="imgassist" src="g./ac30cs/34g.png">
        <img class="imgassist" src="g./afc17s/3fg.png">
      </p>
      <p class="assist">
        第八步:实盘交易
        <span class="red">"确认"</span>后,可以到
        <span class="red">"用户中心"</span>—
        <span class="red">"通知消息"</span>里面进行查询。
      </p>
      <p>
        <img class="imgassist" src="g./adb42s/d0g.png">
        <img class="imgassist" src="g./a70fbs/09g.png">
        <img class="imgassist" src="g./aa7c9s/c6g.png">
        <img class="imgassist" src="g./a46b4s/c1g.png">
      </p>
      <p class="assist">
        第九步：完成后到
        <span class="red">"用户中心"</span>—
        <span class="red">"配资账户"</span>—
        <span class="red">"账户交割"</span>进行，可以直接
        <span class="red">提现</span>或者是继续其他配资。
      </p>
      <p>
        <img class="imgassist" src="../assets/img.png">
        <img class="imgassist" src="../assets/img.png">
        <img class="imgassist" src="../assets/img.png">
      </p>
      <p class="assist">
        第十步：提现：提现前您需要先到
        <span class="red">"用户中心"</span>—
        <span class="red">"实名认证"</span>—认证完即可提现
      </p>
      <p>
        <img class="imgassist" src="../assets/img.png">
        <img class="imgassist" src="../assets/img.png">
        <img class="imgassist" src="../assets/img.png">
      </p>
      <br>
      <p class="assist">
        <span class="red">九龙证券官网:</span>www.hk9999z.com
        <br><br>
        <span class="red">九龙证券平台:</span>www.hk9999z.com
        <br><br>
        <span class="red">九龙证券客服QQ:</span>4006593678
        <br><br>
        <span class="red">九龙证券服务热线:</span>4006593678
      </p>
      <br>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "helpguidelines",
    data(){
      return{
        data:''
      }
    },
    methods:{
      getData(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'protocol',
              'type': 12,
            }
          })  .then(res => {
          let resData = res.data;
          if (res.data.code == 1) {
            that.data = resData.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
      }
    },
    mounted() {
      this.getData();
    }
  }
</script>

<style scoped>
  .article_title {
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>>img{
    width: 100% !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/helpguidelines.vue